import i18n from 'i18next'
import * as Yup from 'yup'

const schema = ({ max_amount }) =>
  Yup.object().shape({
    amount: Yup.string()
      .required('common::validation_messages.required')
      .test(
        'maxAmount',
        i18n.t(
          'services::forms.refund.fields.amount.validation_messages.incorrect_amount_max',
          {
            value: max_amount.value,
            currency: max_amount.currency,
          },
        ),
        function test(value) {
          const { path, createError } = this
          const isValid = parseFloat(value) <= max_amount.value

          return (
            isValid ||
            createError({
              path,
              message: i18n.t(
                'services::forms.refund.fields.amount.validation_messages.incorrect_amount_max',
                {
                  value: max_amount.value,
                  currency: max_amount.currency,
                },
              ),
            })
          )
        },
      ),
  })

export default schema
